<template>
  <div class="disputes-audit-info">
    <div class="title">
      Audit Logs
    </div>

    <div class="content">
      <div class="event">
        {{ `Payment disputed (Reason: ${dispute.reason})` }}
      </div>
      <div class="event-time">
        {{ formatDateWithTimezone(dispute.occurred_at.toString()) }}
        {{ $t('global.time.utcTimeZoneDifference', { time: getUtcTimezoneDifference()}) }}
      </div>

      <div class="event">
        {{ `Payment succeeded` }}
      </div>
      <div class="event-time">
        {{ formatDateWithTimezone(transaction.created_at.toString()) }}
        {{ $t('global.time.utcTimeZoneDifference', { time: getUtcTimezoneDifference()}) }}
      </div>
    </div>
  </div>
</template>

<script>
import {DisputeResponseDto, TransactionResponseDto} from "@/api/paymentApi";
import Formatter from "@/app/utils/common/functions/formatter";
import {getUtcTimezoneDifference} from "@/app/utils/common/functions/dateUtils";

export default {
  name: "DisputeAuditLogs",
  props: {
    dispute: {
      type: DisputeResponseDto,
      required: true,
    },
    transaction: {
      type: TransactionResponseDto,
      required: true,
    },
  },
  methods: {
    getUtcTimezoneDifference,
    formatDateWithTimezone(date) {
      return Formatter.format({type: 'zonedDateWithTime', data: date});
    },
    format(type, data, format, currencyCode) {
      return Formatter.format({type, data, format, currencyCode})
    },
  },
}
</script>

<style lang="scss">
.disputes-audit-info {
  & .title {
    text-align: left;
    font-size: 16px;
    font-weight: $weight-bold;
  }

  & .content {
    margin-top: 12px;
    text-align: left;

    & .event-time {
      color: $neutral_400;
      margin-top: 4px;
      margin-bottom: 16px;
      font-size: 12px;
    }
  }
}
</style>